/*
  File: src/components/Stream/PerformanceSidebar.jsx
  Purpose: Right sidebar with live performance monitoring and analytics.
  Data sources:
  - GET /stream/status
  - GET /stream/health
  - GET /stream/quality
  - GET /stream/log (optional)
  - POST /stream/optimize (on demand)
*/
import React, { useEffect, useState } from 'react';
import { useStreaming } from '../../contexts/StreamingContext';

export default function PerformanceSidebar() {
    const { streamingService } = useStreaming();
    const [status, setStatus] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let mounted = true;
        let timer;
        const poll = async () => {
            try {
                const s = await streamingService.getStatus();
                if (!mounted) return;
                setStatus(s);
            } catch (e) {
                if (!mounted) return;
                setError(e.message || 'Polling failed');
            } finally {
                if (mounted) timer = setTimeout(poll, 4000);
            }
        };
        poll();
        return () => { mounted = false; if (timer) clearTimeout(timer); };
    }, [streamingService]);

    const badge = (txt, color) => (
        <span className={`px-2 py-0.5 rounded text-[10px] font-semibold ${color}`}>{txt}</span>
    );

    // Only render when REACT_APP_SHOW_DEV_PAGES is true
    if (process.env.REACT_APP_SHOW_DEV_PAGES !== 'true') {
        return null;
    }

    return (
        <div className="brand-card backdrop-blur rounded-2xl p-4 space-y-4 text-white">
            <div className="text-sm font-bold">Live Performance</div>

            {error && (
                <div className="text-xs text-red-300 bg-red-900/20 border border-red-500/30 rounded p-2">{error}</div>
            )}

            <div className="rounded-lg border border-white/10 p-3">
                <div className="text-xs text-white/70 mb-1">Status</div>
                <div className="flex items-center gap-2 text-sm">
                    <span>{status?.status || 'unknown'}</span>
                    {status?.ivs_state && badge(`IVS ${status.ivs_state}`, 'bg-white/10')}
                    {status?.ivs_health && badge(`Health ${status.ivs_health}`, status.ivs_health === 'GOOD' ? 'bg-green-600/40' : status.ivs_health === 'POOR' ? 'bg-red-600/40' : 'bg-yellow-600/40')}
                </div>
            </div>
        </div>
    );
}


